// eslint-disable-next-line
import util from 'util';

import React, { Component } from 'react';
import { connect } from 'react-redux';

// eslint-disable-next-line
import * as MuiCore from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
// import SplashLogo from './images/splashlogo.png';

import SnackMessages from './core/SnackMessages';

const styles = theme => ({
  root : {
    backgroundImage: theme.brandingColors.loginGradient,    
    backgroundColor: theme.palette.secondary.main,
    position : 'fixed',
    top: 0, 
    bottom: 0,
    right: 0,
    left: 0, 
  },
  splashLogo : {
    position : 'fixed',
    top : '50%',
    left: '50%',
    transform : 'translate(-50%, -50%)',
  }
});


/*
 * Screen displayed before credentials have been established
 */

class SplashScreen extends Component {
  render() {
    const { classes } = this.props;

    /* Temporary version to remove the logo */
    return (
      <React.Fragment>
        <div className={classes.root}>
        </div>
        <SnackMessages/>
      </React.Fragment>
    );

    /*
    return (
      <React.Fragment>
        <div className={classes.root}>
          <img className={classes.splashLogo}
               alt=''
               src={SplashLogo} />
        </div>
        <SnackMessages/>
      </React.Fragment>
    );
    */
  }
}

const mapStateToProps = (state) => {
  return ({
  });
};

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(SplashScreen));

